
import { Cmd_OfPromise_either } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../../CommunicationV2.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { ofArray, findIndex, length, item as item_1, tryFindIndex, map as map_1, sortBy, empty, contains, filter, singleton } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { InventoryStateDefinition_$reflection, WriteInventoryStateDto_$reflection, InventoryActionModule_all, InventoryKindModule_all, InventoryStateOrderDto_$reflection, InventoryStateOrderDto, InventoryStatesDto, InventoryStateDefinition, InventoryStatesDto_$reflection } from "../../../Shared/InventoryStates.js";
import { ValidationOnGetRequest } from "../../../ErrorHandling.js";
import { FormModule_toDto, FormModule_kindsFor, Form as Form_4, FormModule_ofDefinition, FormModule_empty, State, Msg } from "./Types.js";
import { FormState__setValidationResponse_5219762A, FormState__startLoading, FormState_get_empty, RequestedValue$1 } from "../../../Shared/Shared.js";
import { map } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { safeHash, compareArrays, structuralHash, equals } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Cmd_batch, Cmd_none } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { string_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Cmd_successToast, Cmd_errorToast } from "../../../Components/Toast.js";
import { concat } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";

const reload = Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
    let url_2;
    return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), InventoryStatesDto_$reflection()));
    }, refreshOn)))(true).then((_arg) => {
        const result_1 = _arg;
        return (result_1.tag === 1) ? (Promise.resolve((() => {
            throw new ValidationOnGetRequest(result_1.fields[0]);
        })())) : (Promise.resolve(result_1.fields[0]));
    });
})), "/api/inventory-states", (Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(23, [Item_1])));

export function init() {
    return [new State(new RequestedValue$1(0, []), false, undefined, undefined, FormState_get_empty()), reload];
}

function updateForm(state, change) {
    return new State(state.States, state.LoadFailed, map(change, state.Form), state.PendingDelete, state.FormState);
}

function withItem(item, selected, catalog, items) {
    return filter((candidate) => {
        if (equals(candidate, item) && selected) {
            return true;
        }
        else if (!equals(candidate, item)) {
            return contains(candidate, items, {
                Equals: equals,
                GetHashCode: (x) => (structuralHash(x) | 0),
            });
        }
        else {
            return false;
        }
    }, catalog);
}

function sortedStates(state) {
    const matchValue = state.States;
    if (matchValue.tag === 0) {
        return empty();
    }
    else {
        return sortBy((definition) => [definition.SortOrder, definition.Key], matchValue.fields[0].States, {
            Compare: (x, y) => (compareArrays(x, y) | 0),
        });
    }
}

function moved(key, offset, states) {
    let index;
    const keys = map_1((_arg) => _arg.Key, states);
    const matchValue = tryFindIndex((y) => (key === y), keys);
    let matchResult, index_1;
    if (matchValue != null) {
        if ((index = (matchValue | 0), ((index + offset) >= 0) && ((index + offset) < length(keys)))) {
            matchResult = 0;
            index_1 = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const other = item_1(index_1 + offset, keys);
            return map_1((candidate) => {
                if (candidate === key) {
                    return other;
                }
                else if (candidate === other) {
                    return key;
                }
                else {
                    return candidate;
                }
            }, keys);
        }
        default:
            return undefined;
    }
}

function reorderCmd(state, key, offset) {
    let matchValue_1, dto, dto_1;
    const matchValue = moved(key, offset, sortedStates(state));
    if (matchValue == null) {
        return [state, Cmd_none()];
    }
    else {
        const keys = matchValue;
        return [new State((matchValue_1 = state.States, (matchValue_1.tag === 0) ? (new RequestedValue$1(0, [])) : ((dto = matchValue_1.fields[0], new RequestedValue$1(1, [new InventoryStatesDto(map_1((definition) => (new InventoryStateDefinition(definition.Key, definition.Name, definition.Description, definition.Color, definition.BaseState, definition.AppliesTo, definition.AllowedActions, findIndex((y) => (definition.Key === y), keys), definition.IsSystem, definition.IsArchived)), dto.States), dto.UsageCounts)])))), state.LoadFailed, state.Form, state.PendingDelete, FormState__startLoading(state.FormState)), (dto_1 = (new InventoryStateOrderDto(keys)), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let url_2;
            return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                const pr = response.arrayBuffer();
                return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
            }, refreshOn)))(true);
        })), ["/api/inventory-states/order", toString(0, Auto_generateBoxedEncoder_437914C6(InventoryStateOrderDto_$reflection(), undefined, undefined, undefined)(dto_1))], (Item) => (new Msg(16, [Item])), (Item_1) => (new Msg(23, [Item_1]))))];
    }
}

function failed(state, validation) {
    return [new State(state.States, state.LoadFailed, state.Form, state.PendingDelete, FormState__setValidationResponse_5219762A(state.FormState, validation)), Cmd_errorToast("validation.toast")];
}

export function update(msg, state) {
    switch (msg.tag) {
        case 1:
            return [new State(state.States, false, state.Form, state.PendingDelete, state.FormState), reload];
        case 2:
            return [new State(state.States, state.LoadFailed, FormModule_empty, state.PendingDelete, FormState_get_empty()), Cmd_none()];
        case 3:
            return [new State(state.States, state.LoadFailed, FormModule_ofDefinition(msg.fields[0]), state.PendingDelete, FormState_get_empty()), Cmd_none()];
        case 4:
            return [new State(state.States, state.LoadFailed, undefined, state.PendingDelete, FormState_get_empty()), Cmd_none()];
        case 5:
            return [updateForm(state, (form) => (new Form_4(form.Mode, msg.fields[0], form.Description, form.Color, form.BaseState, form.AppliesTo, form.AllowedActions))), Cmd_none()];
        case 6:
            return [updateForm(state, (form_1) => (new Form_4(form_1.Mode, form_1.Name, msg.fields[0], form_1.Color, form_1.BaseState, form_1.AppliesTo, form_1.AllowedActions))), Cmd_none()];
        case 7:
            return [updateForm(state, (form_2) => (new Form_4(form_2.Mode, form_2.Name, form_2.Description, msg.fields[0], form_2.BaseState, form_2.AppliesTo, form_2.AllowedActions))), Cmd_none()];
        case 8: {
            const baseState = msg.fields[0];
            return [updateForm(state, (form_3) => (new Form_4(form_3.Mode, form_3.Name, form_3.Description, form_3.Color, baseState, filter((kind) => contains(kind, FormModule_kindsFor(baseState), {
                Equals: equals,
                GetHashCode: (x) => (safeHash(x) | 0),
            }), form_3.AppliesTo), form_3.AllowedActions))), Cmd_none()];
        }
        case 9:
            return [updateForm(state, (form_4) => (new Form_4(form_4.Mode, form_4.Name, form_4.Description, form_4.Color, form_4.BaseState, withItem(msg.fields[0], msg.fields[1], InventoryKindModule_all, form_4.AppliesTo), form_4.AllowedActions))), Cmd_none()];
        case 10:
            return [updateForm(state, (form_5) => (new Form_4(form_5.Mode, form_5.Name, form_5.Description, form_5.Color, form_5.BaseState, form_5.AppliesTo, withItem(msg.fields[0], msg.fields[1], InventoryActionModule_all, form_5.AllowedActions)))), Cmd_none()];
        case 11:
            return [updateForm(state, (form_6) => (new Form_4(form_6.Mode, form_6.Name, form_6.Description, form_6.Color, form_6.BaseState, form_6.AppliesTo, msg.fields[0] ? InventoryActionModule_all : empty()))), Cmd_none()];
        case 12: {
            const matchValue = state.Form;
            if (matchValue == null) {
                return [state, Cmd_none()];
            }
            else {
                const form_7 = matchValue;
                let cmd;
                const matchValue_1 = form_7.Mode;
                if (matchValue_1.tag === 1) {
                    const dto_2 = FormModule_toDto(form_7);
                    const body_3 = toString(0, Auto_generateBoxedEncoder_437914C6(WriteInventoryStateDto_$reflection(), undefined, undefined, undefined)(dto_2));
                    cmd = Cmd_OfPromise_either((tupledArg_1) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        let url_5;
                        return ((url_5 = addPrefix(tupledArg_1[0]), (refreshOn_1) => fetchWithDecoder(url_5, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg_1[1]])]), "application/json", (response_2) => {
                            const pr_1 = response_2.arrayBuffer();
                            return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), InventoryStateDefinition_$reflection()));
                        }, refreshOn_1)))(true);
                    })), [concat("/api/inventory-states/", ...matchValue_1.fields[0].Key), body_3], (Item_2) => (new Msg(13, [Item_2])), (Item_3) => (new Msg(23, [Item_3])));
                }
                else {
                    const dto_1 = FormModule_toDto(form_7);
                    cmd = Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        let url_2;
                        return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                            const pr = response.arrayBuffer();
                            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), InventoryStateDefinition_$reflection()));
                        }, refreshOn)))(true);
                    })), ["/api/inventory-states", toString(0, Auto_generateBoxedEncoder_437914C6(WriteInventoryStateDto_$reflection(), undefined, undefined, undefined)(dto_1))], (Item) => (new Msg(13, [Item])), (Item_1) => (new Msg(23, [Item_1])));
                }
                return [new State(state.States, state.LoadFailed, state.Form, state.PendingDelete, FormState__startLoading(state.FormState)), cmd];
            }
        }
        case 13: {
            const response_4 = msg.fields[0];
            if (response_4.tag === 1) {
                return failed(state, response_4.fields[0]);
            }
            else {
                return [new State(state.States, state.LoadFailed, undefined, state.PendingDelete, FormState_get_empty()), Cmd_batch(ofArray([reload, Cmd_successToast("settings.inventory_states.saved")]))];
            }
        }
        case 14:
            return reorderCmd(state, msg.fields[0], -1);
        case 15:
            return reorderCmd(state, msg.fields[0], 1);
        case 16: {
            const response_5 = msg.fields[0];
            if (response_5.tag === 1) {
                const patternInput = failed(state, response_5.fields[0]);
                return [patternInput[0], Cmd_batch(ofArray([patternInput[1], reload]))];
            }
            else {
                return [new State(state.States, state.LoadFailed, state.Form, state.PendingDelete, FormState_get_empty()), Cmd_none()];
            }
        }
        case 17: {
            const archived = msg.fields[1];
            return [new State(state.States, state.LoadFailed, state.Form, state.PendingDelete, FormState__startLoading(state.FormState)), Cmd_OfPromise_either((tupledArg_2) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_8;
                return ((url_8 = addPrefix(tupledArg_2[0]), (refreshOn_2) => fetchWithDecoder(url_8, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg_2[1]])]), "application/json", (response_7) => {
                    const pr_2 = response_7.arrayBuffer();
                    return pr_2.then((blob_2) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_2)), string_type));
                }, refreshOn_2)))(true);
            })), [concat("/api/inventory-states/", msg.fields[0], "/", ...(archived ? "archive" : "restore")), ""], (response_6) => (new Msg(18, [archived, response_6])), (Item_4) => (new Msg(23, [Item_4])))];
        }
        case 18: {
            const response_9 = msg.fields[1];
            if (response_9.tag === 1) {
                return failed(state, response_9.fields[0]);
            }
            else {
                const toastKey = msg.fields[0] ? "settings.inventory_states.archived_toast" : "settings.inventory_states.restored";
                return [new State(state.States, state.LoadFailed, state.Form, state.PendingDelete, FormState_get_empty()), Cmd_batch(ofArray([reload, Cmd_successToast(toastKey)]))];
            }
        }
        case 19:
            return [new State(state.States, state.LoadFailed, state.Form, msg.fields[0], FormState_get_empty()), Cmd_none()];
        case 20:
            return [new State(state.States, state.LoadFailed, state.Form, undefined, FormState_get_empty()), Cmd_none()];
        case 21: {
            const matchValue_2 = state.PendingDelete;
            if (matchValue_2 == null) {
                return [state, Cmd_none()];
            }
            else {
                const definition_3 = matchValue_2;
                return [new State(state.States, state.LoadFailed, state.Form, state.PendingDelete, FormState__startLoading(state.FormState)), Cmd_OfPromise_either((url_9) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_11;
                    return ((url_11 = addPrefix(url_9), (refreshOn_3) => fetchWithDecoder(url_11, singleton(new Types_RequestProperties(0, ["DELETE"])), "application/json", (response_10) => {
                        const pr_3 = response_10.arrayBuffer();
                        return pr_3.then((blob_3) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_3)), string_type));
                    }, refreshOn_3)))(true);
                })), concat("/api/inventory-states/", ...definition_3.Key), (Item_5) => (new Msg(22, [Item_5])), (Item_6) => (new Msg(23, [Item_6])))];
            }
        }
        case 22: {
            const response_12 = msg.fields[0];
            if (response_12.tag === 1) {
                return failed(state, response_12.fields[0]);
            }
            else {
                return [new State(state.States, state.LoadFailed, state.Form, undefined, FormState_get_empty()), Cmd_batch(ofArray([reload, Cmd_successToast("settings.inventory_states.deleted")]))];
            }
        }
        case 23:
            if (state.States.tag === 1) {
                return [new State(state.States, state.LoadFailed, state.Form, state.PendingDelete, FormState_get_empty()), Cmd_batch(ofArray([Cmd_errorToast("general.error"), reload]))];
            }
            else {
                return [new State(state.States, true, state.Form, state.PendingDelete, FormState_get_empty()), Cmd_errorToast("general.error")];
            }
        default:
            return [new State(new RequestedValue$1(1, [msg.fields[0]]), false, state.Form, state.PendingDelete, FormState_get_empty()), Cmd_none()];
    }
}

